import { render, staticRenderFns } from "./Frames.vue?vue&type=template&id=34f918cc"
import script from "./Frames.vue?vue&type=script&lang=js"
export * from "./Frames.vue?vue&type=script&lang=js"
import style0 from "./Frames.vue?vue&type=style&index=0&id=34f918cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports